import { ReactNode } from 'react';
import { LuBarChart3, LuHistory, LuShoppingCart, LuTruck, LuHeadphones, LuHelpCircle, LuLayoutDashboard, LuTag, LuShieldCheck, LuUser } from 'react-icons/lu';
import { Perfil } from '../../../features/auth/types';

export type ItemDaBarra = {
    title: string;
    icon: ReactNode;
    link: string;
    /** Outras rotas em que o item aparece como ativo (o relatorio e aberto pelo dashboard). */
    ativoTambemEm?: string[];
    /** Pagina ainda nao pronta: o item aparece, com uma etiqueta. */
    emBreve?: boolean;
    /** So estes perfis veem o item. Sem a lista, todos veem. */
    perfis?: Perfil[];
};

export type SecaoDaBarra = { titulo: string; itens: ItemDaBarra[] };

export const SidebarData: SecaoDaBarra[] = [
    {
        titulo: 'Menu',
        itens: [
            { title: "Dashboard", icon: <LuLayoutDashboard />, link: "dashboard", ativoTambemEm: ["report", "report-rem"], perfis: ['admin', 'lojista'] },
            { title: "Compras", icon: <LuShoppingCart />, link: "compras" },
            { title: "Remarcações", icon: <LuTag />, link: "remarcacoes", perfis: ['admin', 'lojista'] },
            { title: "Prazos de entrega", icon: <LuTruck />, link: "prazos-entrega", perfis: ['admin', 'lojista'] },
            { title: "Usuários e acessos", icon: <LuShieldCheck />, link: "acessos", perfis: ['admin'] },
            { title: "Histórico", icon: <LuHistory />, link: "historico", perfis: ['admin'] },
            { title: "Perfil", icon: <LuUser />, link: "profile" },
            { title: "Estatísticas", icon: <LuBarChart3 />, link: "stats", emBreve: true },
        ],
    },
    {
        titulo: 'Ajuda',
        itens: [
            { title: "FAQ", icon: <LuHelpCircle />, link: "faq" },
            { title: "Suporte", icon: <LuHeadphones />, link: "support" },
        ],
    },
];

/** Item da barra que corresponde a rota, contando as rotas filhas. */
export function itemDaRota(pathname: string): ItemDaBarra | undefined {
    const trecho = pathname.replace(/^\/app\//, '').split('/')[0];

    for (const secao of SidebarData) {
        const item = secao.itens.find(i => i.link === trecho || i.ativoTambemEm?.includes(trecho));
        if (item) return item;
    }

    return undefined;
}
